import React, { createContext, useContext, useMemo, useState } from "react";

export const ROLES = [
    { id: "broker", label: "Broker Partner A" },
    { id: "underwriter", label: "Underwriter 1" },
    { id: "manager", label: "Underwriting Manager" },
    { id: "product", label: "Product Lead" },
    { id: "claims", label: "Claims Reviewer" },
];

const RoleContext = createContext(null);

export function RoleProvider({ children }) {
    const [roleId, setRoleId] = useState("underwriter");
    const value = useMemo(() => {
        const role = ROLES.find((r) => r.id === roleId) || ROLES[1];
        return { roleId, role, setRoleId };
    }, [roleId]);
    return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
}

export function useRole() {
    const ctx = useContext(RoleContext);
    if (!ctx) throw new Error("useRole must be used inside RoleProvider");
    return ctx;
}

// Authority matrix: which roles can perform which governed action.
export const AUTHORITY = {
    request_clarification: ["underwriter", "manager"],
    submit_evidence: ["broker"],
    record_decision: ["underwriter", "manager"],
    bind_or_release_terms: ["manager"],
    appetite_feedback: ["product", "manager"],
    verify_receipt: ["underwriter", "manager", "product", "claims", "broker"],
};

export function canDo(action, roleId) {
    const allowed = AUTHORITY[action] || [];
    return allowed.includes(roleId);
}
